/* eslint-disable no-useless-constructor */
import React, { useRef, useEffect, useState, useMemo } from 'react'
import { withTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import styles from './Confirmation.module.scss'
import PrintComponent from './PrintComponent'
import SaveCopy from './SaveCopy'

export const PrintContent1 = ({ t, i18n, emailAddress, paymentTransactionNum, transId, transOwner }) => {
  const getPayAFinePrivacyUrl = () => {
    const origin = window.location.origin;
    if (origin.includes('dev-finepayments.ds4u.novascotia.dev')) {
      return i18n.language === 'en'
        ? 'https://dev-finepayments.ds4u.novascotia.dev/en/fine-info'
        : 'https://dev-finepayments.ds4u.novascotia.dev/fr/amendes-info';
    } else if (origin.includes('test-finepayments.ds4u.novascotia.dev')) {
      return i18n.language === 'en'
        ? 'https://test-finepayments.ds4u.novascotia.dev/en/fine-info'
        : 'https://test-finepayments.ds4u.novascotia.dev/fr/amendes-info';
    } else if (origin.includes('uat-finepayments.ds4u.novascotia.dev')) {
      return i18n.language === 'en'
        ? 'https://uat-finepayments.ds4u.novascotia.dev/en/fine-info'
        : 'https://uat-finepayments.ds4u.novascotia.dev/fr/amendes-info';
    } else {
      return i18n.language === 'en'
        ? 'https://finepayment.novascotia.ca/en/fine-info'
        : 'https://finepayment.novascotia.ca/fr/amendes-info';
    }
  }

  const payAFinePrivacyUrl = getPayAFinePrivacyUrl();

  const handleGoBackToStart = (e) => {
    e.preventDefault();
    const url = getPayAFinePrivacyUrl();
    window.location.replace(url);
  }

  return (
    <div className={"container"}>
      <div style={{ display: "flex" }} >
        <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", marginTop: "30px" }}>
          <div className={"col-xs-1 " + styles['success_margin_right']}><i className="fa fa-check-circle fa-2x" aria-hidden="true"></i></div>
          <div style={{ flexGrow: 1, backgroundColor: "green", width: "5px" }} />
        </div>

        <div style={{ flexGrow: 1 }}>
          <div className="col-xs-12">
            <div className="row">
              <div className="col-xs-12">
                <h1 style={{ color: "green" }}>{t('receive_confirmation.title')}</h1>
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12 col-md-8">
                <h2>{t('receive_confirmation.transaction_number')} <strong>{paymentTransactionNum}</strong></h2>
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12 col-md-8">
                <p style={{ marginBottom: '10px' }}>
                  {t('receive_confirmation.we_have_emailed')} <br />
                  {t('receive_confirmation.print_or_save')}
                </p>
              </div>
            </div>

            <div className="print_no_display">
              <div className="row" >
                <div style={{ display: "flex", flexGrow: 1 }} >
                  <div className={styles['display_flex']}>
                    <div className={styles['back_center']}>
                      {typeof InstallTrigger !== 'undefined' || /*@cc_on!@*/ false || !!document.documentMode ? null : (
                        <PrintComponent transId={transId} transOwner={transOwner} />
                      )}
                      <SaveCopy transId={transId} transOwner={transOwner} />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-xs-12 col-md-8">
                  <a href={payAFinePrivacyUrl} className={styles['all_finished_link']} onClick={handleGoBackToStart}>
                    {t('receive_confirmation.all_finished')}
                    <span className="ns-visually-hidden">(ouvre dans un nouvel onglet)</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const ReceiveConfirmationView = ({ t, i18n, setIsError }) => {
  const pageElem = useRef()
  const location = useLocation()

  const [paymentTransactionNum, setPaymentTransactionNum] = useState('')
  const [transId, setTransId] = useState('123456')
  const [transOwner, setTransOwner] = useState('test Test')
  const [emailAddress, setEmailAddress] = useState('')

  const { payeeContactInformation, contactInformation } = useSelector((state) => state.app)

  useEffect(() => {
    try {
      if (!location.state) {
        return;
      }
      if (location.state.transNum) {
        setPaymentTransactionNum(location.state.transNum)
      }
      if (location.state.emailAddress) {
        setEmailAddress(location.state.emailAddress);
      }
      if (location.state.transId) {
        setTransId(location.state.transId);
      }
      if (location.state.transOwner) {
        setTransOwner(location.state.transOwner);
      }
      if (location.state && location.state.transNum && location.state.emailAddress && location.state.transId && location.state.transOwner) {
        setTransId(location.state.transId)
        setTransOwner(location.state.transOwner)
        setEmailAddress(location.state.emailAddress)
      } else {
        // history.push(`/${i18n.language}${t('routes.privacy_notice')}`)
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }, [location.state, setIsError])

  const emailStr = useMemo(() => {
    return payeeContactInformation ? `${emailAddress} ${t('shared.and')} ${contactInformation.email}` : emailAddress
  }, [emailAddress, payeeContactInformation, contactInformation, t])

  const getPayFeesPrivacyUrl = () => {
    const origin = window.location.origin;
    if (origin.includes('dev-finepayments.ds4u.novascotia.dev')) {
      return i18n.language === 'en'
        ? 'https://dev-rmvadminfee.ds4u.novascotia.dev/en/privacy-notice'
        : 'https://dev-rmvadminfee.ds4u.novascotia.dev/fr/avis-de-confidentialite';
    } else if (origin.includes('test-finepayments.ds4u.novascotia.dev')) {
      return i18n.language === 'en'
        ? 'https://test-rmvadminfee.ds4u.novascotia.dev/en/privacy-notice'
        : 'https://test-rmvadminfee.ds4u.novascotia.dev/fr/avis-de-confidentialite';
    } else if (origin.includes('uat-finepayments.ds4u.novascotia.dev')) {
      return i18n.language === 'en'
        ? 'https://uat-rmvadminfee.ds4u.novascotia.dev/en/privacy-notice'
        : 'https://uat-rmvadminfee.ds4u.novascotia.dev/fr/avis-de-confidentialite';
    } else {
      return i18n.language === 'en'
        ? 'https://rmvadminfeepayment.novascotia.ca/en/privacy-notice'
        : 'https://rmvadminfeepayment.novascotia.ca/fr/avis-de-confidentialite';
    }
  }

  const moreInformationOnClick = () => {
    const url = getPayFeesPrivacyUrl();
    window.open(url, '_blank');
  }

  return (
    <React.Fragment>
      <div ref={pageElem} style={{ marginBottom: "2rem" }}>
        <PrintContent1 i18n={i18n} t={t} emailAddress={emailAddress} paymentTransactionNum={paymentTransactionNum} transId={transId} transOwner={transOwner} />
        <div className="container">

          <div className="row">
            <div className="col-xs-12 col-md-8">
              <h2>{t('receive_confirmation.what_happens_next')}</h2>
              <div className="row">
                <div className="col-xs-12">
                  <strong>{t('receive_confirmation.confirmation_email_title')}</strong>
                  <br />
                  {t('receive_confirmation.confirmation_email')}{emailStr}
                  <br />
                  {t('receive_confirmation.confirmation_email_info')}
                </div>
              </div>
              <br />
              <div className="row">
                <div className="col-xs-12 col-md-8">
                  <strong>{t('receive_confirmation.payment_processed')}</strong>
                  <br />
                  {t('receive_confirmation.changes_will_app')}
                </div>
              </div>
              <div className="row">
                <div className="col-xs-12 col-md-8">
                  <h2>{t('receive_confirmation.if_you_have_questions')}</h2>
                  {t('receive_confirmation.if_you_have_questions_info')}
                </div>
              </div>
              <br />
              <div className="row">
                <div className="col-md-8">
                  <div style={{ display: "flex", flexGrow: 1 }}>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <span><strong>{t('receive_confirmation.contact')}</strong></span>
                      <span><strong>{t('receive_confirmation.telephone')}</strong></span>
                      <span><strong>{t('receive_confirmation.email')}</strong></span>
                    </div>
                    <div style={{ display: "flex", flexDirection: "column", marginLeft: "2rem" }}>
                      <span><a href='https://novascotia.ca/just/?_ga=2.185104047.761454033.1644255999-1395488286.1633464315' target='_blank'>{t('contact_information.department_of_justice')}
                        <span className="ns-visually-hidden">(ouvre dans un nouvel onglet)</span>
                      </a></span>
                      <span><a href={`tel:${t('receive_confirmation.telephone_num')}`}>{t('receive_confirmation.telephone_num')}
                        <span className="ns-visually-hidden">(ouvre dans un nouvel onglet)</span>
                      </a></span>
                      <span><a href={`mailto:${t('receive_confirmation.email_address')}`}>{t('receive_confirmation.email_address')}
                        <span className="ns-visually-hidden">(ouvre dans un nouvel onglet)</span>
                      </a></span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-xs-12 col-md-8">
                  <h2>{t('receive_confirmation.late_paying_your_fine')}</h2>
                  {t('receive_confirmation.if_you_did_not')}
                  <br />
                  <br />
                  <button
                    style={{ marginTop: '10px' }}
                    onClick={moreInformationOnClick}
                    value={t('receive_confirmation.more_information')}
                    name={t('receive_confirmation.more_information')}
                    className="btn-lg btn-default"
                  >
                    {t('receive_confirmation.more_information')}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default withTranslation('common')(ReceiveConfirmationView)
